import { render, staticRenderFns } from "./NoteListeNotificationsClientArea.vue?vue&type=template&id=3b7ff86f&"
import script from "./NoteListeNotificationsClientArea.vue?vue&type=script&lang=js&"
export * from "./NoteListeNotificationsClientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports